import { styled } from 'styled-components';

import { LargeContainer } from 'src/components/container';
import { breakpointLargeTablet, breakpointTablet } from 'src/styles/breakpoints';
import { colorSecondary900 } from 'src/styles/colors';
import { spacing2, spacing6, spacing7, spacing9, spacing18, spacing5 } from 'src/styles/spacing';

export const StyledFooter = styled.footer`
  background: ${colorSecondary900};
`;

export const StyledLogoAndLinksContainer = styled(LargeContainer)`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  padding: ${spacing6} ${spacing7} ${spacing18};

  @media (min-width: ${breakpointTablet}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  @media (min-width: ${breakpointLargeTablet}) {
    padding-bottom: ${spacing9};
    padding-left: ${spacing2};
    padding-right: ${spacing2};
  }
`;

export const StyledLinks = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-bottom: ${spacing5};
  flex-shrink: 0;

  @media (min-width: ${breakpointTablet}) {
    margin-bottom: 0;
  }

  @media (min-width: ${breakpointLargeTablet}) {
    flex-direction: row;
  }
`;
